import {createPinia, type Pinia} from 'pinia';

let piniaInstance: Pinia | null = null;
export function getPinia(): Pinia {
  if (piniaInstance === null) {
    piniaInstance = createPinia();
  }

  return piniaInstance;
}
